import React, { useEffect, useState } from "react";
import { apiClient } from "@/lib/apiClient";
import { Loader2 } from "lucide-react";

const fmt = (v, cur = "CHF") => new Intl.NumberFormat("de-CH", { style: "currency", currency: /^[A-Za-z]{3}$/.test(cur || "") ? cur.toUpperCase() : "CHF" }).format(Number(v || 0));

/** Weiterbelastung beim Übertragen: nur verschieben / Kontokorrent / Rechnung – mit Vorschau der Buchungen. */
export function RechargeOptions({ companyId, item, targetId, value, onChange }) {
  const [pv, setPv] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!item || !targetId) { setPv(null); return; }
    let alive = true;
    setLoading(true);
    apiClient.get(`/companies/${companyId}/inbox/${item.id}/recharge-preview`, { params: { target_company_id: targetId } })
      .then((r) => alive && setPv(r.data)).catch(() => alive && setPv(null)).finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, [companyId, item, targetId]);

  if (!targetId) return null;
  const noAmount = pv && !(pv.amount > 0);
  const opt = (key, title, body, disabled) => (
    <label key={key} className={`flex gap-2.5 rounded-md border p-2.5 cursor-pointer ${value === key ? "border-indigo-400 bg-indigo-50/60" : "border-slate-200 hover:bg-slate-50"} ${disabled ? "opacity-50 cursor-not-allowed" : ""}`} data-testid={`inbox-move-recharge-${key}`}>
      <input type="radio" name="recharge" className="mt-0.5" checked={value === key} disabled={disabled} onChange={() => onChange(key)} />
      <span className="text-xs">
        <span className="font-medium text-slate-800 block">{title}</span>
        <span className="text-slate-600 block mt-0.5">{body}</span>
      </span>
    </label>
  );

  return (
    <div className="space-y-1.5" data-testid="inbox-move-recharge">
      <p className="text-[11px] uppercase tracking-wide text-slate-400 flex items-center gap-1.5">
        Weiterbelastung {loading && <Loader2 className="h-3 w-3 animate-spin" />}
      </p>
      {noAmount && <p className="text-[11px] text-amber-700 bg-amber-50 border border-amber-200 rounded px-2 py-1" data-testid="inbox-move-recharge-noamount">Kein Betrag erkannt – Weiterbelastung erst nach Erfassen des Betrags möglich.</p>}
      {opt("none", "Nur verschieben", `Beleg wandert in den Posteingang von ${pv?.target_name || "der Zielfirma"} – keine Gegenbuchung.`)}
      {opt("kontokorrent", "Kontokorrent-Buchung (konzernintern, einfach)",
        pv ? `${pv.source_name}: offener Beleg ${fmt(pv.amount, pv.currency)} auf ${pv.kontokorrent.source_account} (wird beim Bankabgleich verknüpft). ${pv.target_name}: Beleg im Posteingang, beim Bestätigen Aufwand an ${pv.kontokorrent.target_account}.` : "…", noAmount)}
      {opt("invoice", `Weiterbelastungs-Rechnung${pv?.invoice?.with_vat ? " (mit MWST)" : " (ohne MWST)"}`,
        pv ? `Beleg bleibt als Aufwand bei ${pv.source_name}. Rechnung ${pv.invoice.number} an ${pv.target_name}: ${fmt(pv.invoice.net, pv.currency)}${pv.invoice.with_vat ? ` + ${pv.invoice.vat_rate}% MWST ${fmt(pv.invoice.tax, pv.currency)}` : ""} = ${fmt(pv.invoice.total, pv.currency)}, gebucht. Bei ${pv.target_name} als offene Eingangsrechnung mit Beleg als Beilage.` : "…", noAmount)}
    </div>
  );
}
